import Axios from "axios";
import { GET_EARNINGS_CODES } from "../../types";

/**
 * @deprecated
 * @param {*} companyId 
 * @returns 
 */
export const getCompanyEarningCodes = (companyId) => async (dispatch) => {
  if (!companyId) return;
  let conversionTools = await Axios.post(`api/earning-codes/get-earning-codes-by-company/${companyId}`);
  dispatch({
    type: GET_EARNINGS_CODES,
    payload: conversionTools.data.data,
  });
};
